import { COUNTRIES } from "@/config/countries";
import * as constants from "@/config/constants";

const certFilters = [
  {
    id: "subjectType",
    title: "Subject type",
    value: "End entity",
    selected: true,
    required: true,
    menuModel: false,
    type: "select",
    items: [
      { title: "End entity", selected: true, id: "EE" },
      { title: "Certificate authority", selected: false, id: "CA" }
    ]
  },
  {
    id: "certificateSerialNumber",
    title: "Certificate serial number",
    value: "",
    selected: true,
    menuModel: false,
    textFieldModel: "",
    type: "textField",
    dropDownItems: [
      "Matches",
      "Contains",
      "Starts with",
      "Ends with",
    ],
    dropDownModel: 'Matches'
  },
  {
    id: "subjectCommonName",
    title: "Subject common name",
    value: "",
    selected: true,
    menuModel: false,
    textFieldModel: "",
    type: "textField",
    dropDownItems: [
      "Matches",
      "Contains",
      "Starts with",
      "Ends with",
    ],
    dropDownModel: 'Matches'
  },
  {
    id: "subjectGivenName",
    title: "Subject given name",
    value: "",
    selected: false,
    menuModel: false,
    textFieldModel: "",
    type: "textField",
    dropDownItems: [
      "Matches",
      "Contains",
      "Starts with",
      "Ends with",
    ],
    dropDownModel: 'Matches'
  },
  {
    id: "subjectSurName",
    title: "Subject surname",
    value: "",
    selected: false,
    menuModel: false,
    textFieldModel: "",
    type: "textField",
    dropDownItems: [
      "Matches",
      "Contains",
      "Starts with",
      "Ends with",
    ],
    dropDownModel: 'Matches'
  },
  {
    id: "subjectOrganisationName",
    title: "Subject organisation name",
    value: "",
    selected: false,
    menuModel: false,
    textFieldModel: "",
    type: "textField",
    dropDownItems: [
      "Matches",
      "Contains",
      "Starts with",
      "Ends with",
    ],
    dropDownModel: 'Matches'
  },
  {
    id: "subjectOrganisationUnit",
    title: "Subject organisation unit",
    value: "",
    selected: false,
    menuModel: false,
    textFieldModel: "",
    type: "textField",
    dropDownItems: [
      "Matches",
      "Contains",
      "Starts with",
      "Ends with",
    ],
    dropDownModel: 'Matches'
  },
  {
    id: "subjectSerialNumber",
    title: "Subject serial number",
    value: "",
    selected: false,
    menuModel: false,
    textFieldModel: "",
    type: "textField",
    dropDownItems: [
      "Matches",
      "Contains",
      "Starts with",
      "Ends with",
    ],
    dropDownModel: 'Matches'
  },
  {
    id: "subjectCountry",
    title: "Subject country",
    selected: false,
    menuModel: false,
    type: "autocomplete",
    queryFilter: (item, query) => {
      if (query.length === 2) {
        return item.id.toLocaleLowerCase() === query.toLocaleLowerCase();
      }
      return item.title.toLocaleLowerCase().includes(query.toLocaleLowerCase());
    },
    items: Object.entries(COUNTRIES).map(([id, name]) => {
      return {
        title: `${name} (${id})`,
        id: id
      }
    })
  },
  {
    id: "status",
    title: "Status",
    selected: true,
    menuModel: false,
    type: "multiSelect",
    items: [
      { id: "isExpired", title: "Is expired", selected: false },
      { id: "isNotYetValid", title: "Is not yet valid", selected: false },
      { id: "isNotRevoked", title: "Is not revoked", selected: false },
      { id: "isRevoked", title: "Is revoked", selected: false }
    ],
  },
  {
    id: "revocationReason",
    title: "Revocation reason",
    selected: false,
    menuModel: false,
    type: "multiSelect",
    items: constants.REVOCATION_REASONS.map(reason => ({
      title: reason.title,
      selected: false,
      id: reason.id
    })),
  },
  {
    id: {
      from: "revocationTimeFrom",
      to: "revocationTimeTo"
    },
    title: "Revoked by date",
    value: {},
    selected: false,
    menuModel: false,
    type: "date",
    radioGroup: 1,
    models: {
      isOn: "",
      isBefore: "",
      isAfter: "",
      isInTheRange: "",
      isWithin: "",
    },
    dropDownItems: [
      { id: 'isOn', name: 'Is on' },
      { id: 'isBefore', name: 'Is before' },
      { id: 'isAfter', name: 'Is after' },
      { id: 'isInTheRange', name: 'Is in the range' },
      { id: 'isWithin', name: 'Is within' }
    ],
    dropDownModel: { id: 'isOn', name: 'Is on' },
    dateFromMenuModel: false,
    dateToMenuModel: false,
    dateFrom: '',
    dateTo: ''

  },
  {
    id: "publicationAllowed",
    title: "Publication allowed",
    type: "soloCheckBox",
    status: "All",
    selected: false,
    menuModel: false,
  },
  {
    id: {
      from: "validFromTimeFrom",
      to: "ValidFromTimeTo"
    },
    title: "Valid from",
    value: {},
    selected: false,
    menuModel: false,
    type: "date",
    radioGroup: 1,
    models: {
      isOn: "",
      isBefore: "",
      isAfter: "",
      isInTheRange: "",
      isWithin: "",
    },
    dropDownItems: [
      { id: "isOn", name: "Is on" },
      { id: "isBefore", name: "Is before" },
      { id: "isAfter", name: "Is after" },
      { id: "isInTheRange", name: "Is in the range" },
      { id: "isWithin", name: "Is within" }
    ],
    dropDownModel: { id: "isOn", name: "Is on" },
    dateFromMenuModel: false,
    dateToMenuModel: false,
    dateFrom: "",
    dateTo: ""
  },
  {
    id: {
      from: "validToTimeFrom",
      to: "validToTimeTo"
    },
    title: "Valid to",
    value: {},
    selected: true,
    menuModel: false,
    type: "date",
    radioGroup: 1,
    models: {
      isOn: "",
      isBefore: "",
      isAfter: "",
      isInTheRange: "",
      isWithin: "",
    },
    dropDownItems: [
      { id: "isOn", name: "Is on" },
      { id: "isBefore", name: "Is before" },
      { id: "isAfter", name: "Is after" },
      { id: "isInTheRange", name: "Is in the range" },
      { id: "isWithin", name: "Is within" }
    ],
    dropDownModel: { id: "isInTheRange", name: "Is in the range" },
    dateFromMenuModel: false,
    dateToMenuModel: false,
    dateFrom: "",
    dateTo: "",
  },
]

const regFilters = [
  {
    id: "procid",
    value: "",
    title: "Registration procedure",
    selected: true,
    required: true,
    menuModel: false,
    type: "select",
    items: "",
  },
  {
    id: "status",
    title: "Status",
    value: "",
    selected: true,
    menuModel: false,
    type: "select",
    items: [
      { title: "Open", selected: false, id: "open" },
      { title: "Closed", selected: false, id: "closed" },
      { title: "All", selected: true, id: "all" }
    ]
  },
  {
    id: "validity",
    title: "Validity",
    value: "",
    selected: true,
    menuModel: false,
    type: "textField",
    dropDownItems: [
      "Limited",
      "Always",
      "All"
    ],
    dropDownModel: "Matches",
  },
  {
    id: "officer",
    title: "Officer",
    value: "",
    selected: true,
    menuModel: false,
    textFieldModel: "",
    type: "textField",
    dropDownItems: [
      "Matches",
      "Contains",
      "Starts with",
      "Ends with",
    ],
    dropDownModel: "Matches",
  },
  {
    id: "fqdn",
    title: "FQDN",
    value: "",
    selected: false,
    menuModel: false,
    textFieldModel: "",
    type: "textField",
    dropDownItems: [
      "Matches",
      "Contains",
      "Starts with",
      "Ends with"
    ],
    dropDownModel: "Matches",
  },
];

export { certFilters, regFilters }